// extracted by mini-css-extract-plugin
export var activityContainer = "_kd-0";
export var typingIndicatorContainer = "_kd-1";
export var typingIndicatorDot = "_kd-2";
export var wave = "_kd-3";